import Vue from 'vue'
import App from './App'
import router from './router'
import './common/css/reset.css'
import './common/css/ele.css'
import './components/common.js'
import ElementUI from 'element-ui'
import directives from './common/js/directives' // 自定义指令
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(directives)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js